import React, { Component } from 'react';
import { Button, ConfirmationBox, PageHeader, PageTitle, PdfViewer, Spinner } from '../../components/index.js';
import { createServiceAction } from '../../util/actionHelper.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectEmail, selectFullName, selectUserDetails } from '../../reducers/authReducer.js';
import { getEnableTrainingMaterialSubmit } from '../../reducers/dashboardReducer.js';
import { 
  selectActiveTrainingMaterialLoading, 
  selectActiveTrainingMaterialData, 
  selectActiveTrainingMaterialError 
} from '../../reducers/trainingReducer.js';
import { fetchActiveTrainingMaterial } from '../../actions/trainingActions.js';

export class TrainingMaterials extends Component {
  state = {
    trainingMaterialsAgreed: false,
    submitModal: false
  };

  componentDidMount() {
    const { fetchActiveTrainingMaterial } = this.props;
    fetchActiveTrainingMaterial();
  }

  handleTrainingMaterialsAgreed = (event) => {
    this.setState({ trainingMaterialsAgreed: event.target.checked });
  }

  openConfirmationPopup = () => {
    this.setState({ submitModal: true });
  }

  closeSubmitModal = () => {
    this.setState({ submitModal: false });
  }

  handleAcceptTrainingMaterial = () => {
    const {
      email,
      fullName,
      shouldEnableTrainingMaterialSubmit,
      submitTrainingMaterialAcknowledgement,
      userDetails
    } = this.props;
    const { trainingMaterialsAgreed } = this.state;

    if (!trainingMaterialsAgreed) {
      return;
    }

    shouldEnableTrainingMaterialSubmit(true);
    submitTrainingMaterialAcknowledgement({
      name: fullName || userDetails.userName,
      email,
      userID: userDetails.userId,
      userType: userDetails.group || userDetails.userType,
      supplierName: userDetails.supplierName || null,
      supplierOrLocationId: userDetails.supplierId || null,
      contact: userDetails.contact || null,
      labId: userDetails.labId || null,
      trainingMaterial: true
    });
  }

  render() {
    const { isEmbedded, trainingMaterialSubmitting, userDetails, loading, trainingMaterialData, error } = this.props;
    const { trainingMaterialsAgreed, submitModal } = this.state;
    const pdfDataUrl = trainingMaterialData?.downloadUrl;
    const userType = userDetails.group || userDetails.userType;
    const isSupplierOrFactory = userType === 'Suppliers' || userType === 'Factories';
    const isTrainingMaterialCompleted = userDetails.TrainingMaterialStatus === 'completed';
    
    return (
      <div className={isEmbedded ? "" : "userpage"}>
        <div className={isEmbedded ? "" : "pdf-align-items pdf-page-bottom-align"}>
          {!isEmbedded && (
            <>
              <PageTitle title="Training Materials" />
              <PageHeader title="Training Materials">
                <div className="user-page">
                  <i className="fas fa-graduation-cap"></i>
                </div>
              </PageHeader>
            </>
          )}
          
          <div id="english-pdf"></div>
          {loading ? (
            <Spinner large text="Fetching Training Material..." />
          ) : error ? (
            <div className="text-center p2 text-color-error">{error}</div>
          ) : pdfDataUrl ? (
            <PdfViewer s3DataUrl={pdfDataUrl} containerId="english-pdf" />
          ) : (
            <div className="text-center p2">No training material available</div>
          )}
          
          {isEmbedded && isSupplierOrFactory && (
            <div style={{ marginTop: '20px', padding: '15px', borderTop: '1px solid #ddd' }}>
              <label style={{ display: 'flex', alignItems: 'flex-start', cursor: isTrainingMaterialCompleted ? 'default' : 'pointer' }}>
                <input
                  type="checkbox"
                  checked={isTrainingMaterialCompleted || trainingMaterialsAgreed}
                  onChange={this.handleTrainingMaterialsAgreed}
                  disabled={isTrainingMaterialCompleted}
                  style={{ marginRight: '10px', marginTop: '2px' }}
                />
                <span style={{ fontSize: '0.95rem', lineHeight: '1.5' }}>
                  I confirm I have read and understood the Nike RSL Training Materials.
                </span>
              </label>
              {!isTrainingMaterialCompleted && (
                <Button
                  className={`ncss-btn-primary-dark u-bold submit-button-enable trf-button-selected mt2-sm ${(!trainingMaterialsAgreed || trainingMaterialSubmitting) ? 'disabled' : ''}`}
                  disabled={!trainingMaterialsAgreed || trainingMaterialSubmitting}
                  onClick={this.openConfirmationPopup}
                >
                  SUBMIT
                </Button>
              )}
              <ConfirmationBox
                message="Are you sure you want to confirm that you have read and understood the Nike RSL Training Materials?"
                submitModal={submitModal}
                submitValue={this.handleAcceptTrainingMaterial}
                closeModal={this.closeSubmitModal}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  email: selectEmail(state),
  fullName: selectFullName(state),
  userDetails: selectUserDetails(state),
  trainingMaterialSubmitting: getEnableTrainingMaterialSubmit(state),
  loading: selectActiveTrainingMaterialLoading(state),
  trainingMaterialData: selectActiveTrainingMaterialData(state),
  error: selectActiveTrainingMaterialError(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  shouldEnableTrainingMaterialSubmit: data => createServiceAction('enableTrainingMaterial', 'requested')(data),
  submitTrainingMaterialAcknowledgement: data => createServiceAction('updateUserProfile', 'requested')(data),
  fetchActiveTrainingMaterial
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TrainingMaterials);